import React, { forwardRef, useMemo } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../common/SvgIcon';
import { isZipValid, isPhoneValid } from '../utils/validation';
import FormInput from '../../../pro_platform_sign_up/components/FormInput';

const GettingStartedAddress = (
  { value, children, proPlatform, className, invalid, onChange, ...rest },
  ref,
) => {
  const isDirty = useMemo(() => Object.values(value).some(v => !!(v || '').length), [value]);
  return (
    <div {...rest} ref={ref} className={cn('tab', className)}>
      <div className="tab_question">{`Question ${proPlatform ? '5 of 5' : '6 of 7'}`}</div>
      <div className="tab_tag">
        <SvgIcon icon="icon-question-step-9" />
      </div>
      <div className="tab_title">
        <div className={cn({ 'has-error -error-position-right': invalid })}>
          {"What's your address?"}
          {invalid && <div className="form-error">please, fill in your address details</div>}
        </div>
      </div>

      <div className="getting-started_address">
        <div className="onboarding-fields">
          <div className="clearfix">
            <div
              className={cn('onboarding-fields_col -w50', {
                'has-error': (isDirty || invalid) && !value.address,
              })}
            >
              <FormInput
                type="text"
                value={value.address}
                placeholder="Address"
                className="form-control"
                onChange={address => onChange({ ...value, address })}
              />
            </div>

            <div
              className={cn('onboarding-fields_col -w25', {
                'has-error': (isDirty || invalid) && !value.town,
              })}
            >
              <FormInput
                type="text"
                placeholder="Town"
                className="form-control"
                value={value.town}
                onChange={town => onChange({ ...value, town })}
              />
            </div>

            <div
              className={cn('onboarding-fields_col -w25', {
                'has-error': (isDirty || invalid) && !isZipValid(value.postcode),
              })}
            >
              <FormInput
                type="text"
                placeholder="Postcode"
                className="form-control"
                value={value.postcode}
                onChange={postcode => onChange({ ...value, postcode })}
              />
            </div>
          </div>

          <div
            className={cn('onboarding-fields_col -w50', {
              'has-error': (isDirty || invalid) && !isPhoneValid(value.phone),
            })}
          >
            <FormInput
              type="text"
              className="form-control"
              placeholder="Phone"
              value={value.phone}
              hideMask
              onChange={phone => onChange({ ...value, phone })}
            />
          </div>

          <div className="onboarding-fields_col -w50">
            <div className="onboarding-fields_label">
              <span>Please include the best phone number for your designer to contact you on</span>
            </div>
          </div>
        </div>
      </div>

      {children}

      {!proPlatform && (
        <div className="tab_hint">
          We use this information to view your property and floor plans online.
          <br />
          Please remember we value your privacy and will never lease, rent or sell your private
          information. For more details visit our <a href="/privacy">Privacy Policy.</a>
        </div>
      )}
    </div>
  );
};

export default forwardRef(GettingStartedAddress);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedAddress.js